import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchFlyersByStore } from '../api/thamanService';
import Loader from '../components/Loader';
import ErrorMessage from '../components/ErrorMessage';

export default function FlyersListPage() {
  const [flyers, setFlyers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // useParams is a hook from React Router that lets us read the URL parameters (like :storeId)
  const { storeId } = useParams();

  useEffect(() => {
    const getFlyers = async () => {
      try {
        setError(null);
        setIsLoading(true);
        const data = await fetchFlyersByStore(storeId);
        setFlyers(data);
      } catch (err) {
        setError('Failed to fetch flyers.');
      } finally {
        setIsLoading(false);
      }
    };

    getFlyers();
  }, [storeId]); // This effect re-runs if the storeId in the URL changes

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Flyers for Store #{storeId}</h1>

      {isLoading && <Loader message="Fetching flyers..." />}
      {error && <ErrorMessage message={error} />}

      {!isLoading && !error && (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {flyers.length > 0 ? (
            flyers.map(flyer => (
              // 2. WRAP the div in a Link component
              <Link key={flyer.id} to={`/flyers/${flyer.id}/pages`}>
                <div className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow">
                  <p className="font-bold text-lg">{flyer.english_name}</p>
                  <p className="text-sm text-gray-500">{flyer.arabic_name}</p>
                  <p className="text-xs text-gray-400 mt-2">
                    Valid from {new Date(flyer.valid_from).toLocaleDateString()} to {new Date(flyer.valid_to).toLocaleDateString()}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    Uploaded by: {flyer.uploaded_by_name || 'Unknown'}
                  </p>
                </div>
              </Link>
            ))
          ) : (
            <p className="col-span-full text-center text-gray-500 py-4">No flyers found for this store.</p>
          )}
        </div>
      )}
    </div>
  );
}